import moment from "moment";

const CSV_FILE_TYPE = "text/csv;charset=utf-8;";

export const exportToCSV = ({ orgName, orgAnalytics, cases }) => {
  const _cases = [];

  if (cases?.length > 0) {
    for (let i = 0; i < cases?.length; i++) {
      const _case = cases[i];

      const obj = {
        id: _case?.id,
        name: `${_case?.referral?.user?.firstName} ${_case?.referral?.user?.lastName}`,
        email: `${_case?.referral?.user?.email}`,
        "case number": _case?.caseNumber,
        "referral source": _case?.referral?.from,
        service: _case?.referral?.serviceName,
        status: _case?.status,
        createdAt: `${moment(_case?.createdAt).format("DD MM YYYY")} ${moment(
          _case?.createdAt,
        ).format("LT")}`,
      };

      _cases.push(obj);
    }
  }

  const dataObject = { ...orgAnalytics, _cases };

  const tables = [orgName, "\n"];

  // Loop through each property in the JSON data
  for (const [propertyName, propertyValue] of Object.entries(dataObject)) {
    // Convert the property value to an array of objects
    const data = propertyValue.map((obj) => ({ ...obj }));

    // Determine the set of all possible keys
    const allKeys = data.reduce((keys, obj) => {
      Object.keys(obj).forEach((key) => keys.add(key));
      return keys;
    }, new Set());

    // Generate the header row and rows of data
    const header = Array.from(allKeys).join(",");
    const rows = data.map((obj) => {
      const values = Array.from(allKeys).map((key) => obj[key] || "");
      return values.join(",");
    });

    // Concatenate the header and rows together into a single string
    const csv = [propertyName, header, ...rows].join("\n");

    // Add the CSV data to the array of tables
    tables.push(csv);
  }

  // Separate each table with 5 empty rows
  const finalCsv = tables.join("\n\n\n\n\n");

  // BOM support for special characters in Excel
  const byteOrderMark = "\ufeff";

  const blob = new Blob([byteOrderMark, finalCsv], {
    type: CSV_FILE_TYPE,
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${orgName} analytics data`;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // const dataToConvert = {
  //   data: finalData,
  //   filename: `${orgName} impact report`,
  //   delimiter: ",",
  //   headers: ["IP", "Full Name", "IP Address"],
  // };
};
